import { styled, Typography } from "@mui/material";

type MultiLineTextProps = {
	clamp?: number;
};

export const MultiLineText = styled(Typography, {
	shouldForwardProp: (prop) => prop !== "clamp",
})<MultiLineTextProps>(({ clamp }) => ({
	whiteSpace: "pre-line",
	overflowWrap: "break-word",
	display: "-webkit-box",
	WebkitBoxOrient: "vertical",
	overflow: "hidden",
	maxWidth: "100%",
	WebkitLineClamp: clamp ?? "unset",
}));
